import LoginForm from './LoginForm.vue';

export default LoginForm;
